module.exports = __webpack_public_path__ + "static/media/logo_vietcredit.62de1db4.svg";